import type { PublicSlotKey } from '#packages/apilib';
import type { SiteSegmentMediaBackgroundPublicApi } from './api';

export const SiteSegmentMediaBackgroundApiKey: PublicSlotKey<SiteSegmentMediaBackgroundPublicApi> =
  {
    name: 'SiteSegmentMediaBackgroundApi',
    public: true,
  };
